export const es = {
  language: "ES",
  name: "Español",
  global: {
    buttons: {
      confirm: "Confirmar",
      cancel: "Cancelar",
      save: "Guardar",
      print: "Imprimir",
    },
    inputs: {
      ruleName: "Reglas",
      select: "Seleccione una opción",
      rules: {
        required: "Debe tener un valor",
        upperCaseLimited: "Debe contener al menos {quantity} letras mayusculas",
        lowerCaseLimited: "Debe contener al menos {quantity} letras minusculas",
        especialCharactersLimited:
          "Debe contener al menos {quantity} caracteres especiales",
        numberCharactersLimited:
          "Debe contener al menos {quantity} caracteres numericos",
        minQuantity: "Debe contener al menos {quantity} caracteres",
        numberCharacters: "Debe estar compuesta de caracteres numericos",
        email: "Debe ser una dirección de correo válida",
        onlyNumber: "Debe ser un número",
        positiveNumber: "Debe ser un número positivo",
        isOptional: "Es opcional",
        isLess: "Debe ser menor o igual que {num}",
        isGreater: "Debe ser mayor o igual que {num}",
        isCoordinates: "Deben ser coordenadas de Google Maps",
      },
      noOptions: "Lo sentimos, no hay opciones disponibles",
      dragAndDrop: "Arrastre y suelte archivos",
    },
    warnings: {
      delete: "Atención de eliminación",
    },
    tables: {
      results: "Resultados: ",
      resultsPerPage: "Resultados por página",
      emptyData:
        "Reajusta los filtros, no hay datos que correspondan a estos criterios",
      selectNull: "Seleccionar {entity}",
      showingPage: "Mostrando página {currentPage} de {totalPages}",
      filtersApplied: "Filtros aplicados",
    },
    errors: {
      imageTooBig: "La imagen es demasiado grande",
      tooFiles: "No se pueden agregar muchos archivos",
      typesWrong: "El/los tipo(s) de/los archivo(s) son incompatible(s)",
    },
    UNKNOWN_ERROR:
      "Ha ocurrido un error inesperado, por favor, contacta a soporte",
  },
  dashboard: {
    employee: "Empleado",
    earnings: "Ingresos",
    title: "Sistema para administración",
    statistics: "Estadísticas",
    customers: "CLIENTES",
    sales: "VENTAS",
    soldsDetails: "DETALLES DE VENTAS",
    thisWeek: "ESTA SEMANA",
    totalBalance: "Balance Total",
    lastTransactions: "ÚLTIMOS MOVIMIENTOS",
  },
  excel: {
    entity: {
      file: "Archivo",
    },
    form: {
      upload: "Subir",
    },
    errors: {
      title: "Entrada inválida",
      date: "El campo debe contener una fecha",
      number: "El campo debe contener un número",
      select: "El campo seleccionado no existe",
    },
  },
  auth: {
    carouselTabs: {
      signUp: {
        primaryTitle: "ACCESO A QUICK PALLET",
        secondaryTitle: "INGRESA TU CORREO Y PASSWORD",
        hrefs: {
          validateEmail: "Deseas validar tu email?",
          recoveryPassword: "Has olvidado tu contraseña?",
        },
        anotherAccessOptions: "O continúa con",
        submit: "ENTRAR",
      },
      forgotPassword: {
        primaryTitle: "Recupera tu contraseña!",
        submit1: "RECUPERAR",
        submit2: "CAMBIAR",
        hrefs: {
          haveACodeYet: "Ya tengo un código!",
          notHaveACodeYet: "No tengo un código!",
          signUp: "Iniciar sesión",
        },
      },
      validateEmail: {
        primaryTitle: "Validá tu correo electrónico",
        hrefs: {
          haveACodeYet: "Ya tengo un código!",
          notHaveACodeYet: "No tengo un código!",
          signUp: "Iniciar sesión",
        },
        submit1: "ENVIAR",
        submit2: "VALIDAR",
      },
      changePassword: {
        primaryTitle: "Cambia tu contraseña",
      },
    },
    fields: {
      email: "Correo",
      password: "Contraseña",
      confirmationCode: "Código de confirmación",
      newPassword: "Nueva contraseña",
      oldPassword: "Contraseña anterior",
    },
    errors: {
      CREDENTIALS_UNKNOWN: "Datos incorrectos, intentalo de nuevo.",
      ATTEMPTS_LIMIT_EXCEEDED:
        "Lo has intentado muchas veces, intenta de nuevo mas tarde.",
      INVALID_CODE: "El código es inválido.",
      INVALID_PASSWORD: "La contraseña es inválida.",
      NOT_AUTHORIZED: "Este correo ya está validado.",
      ACCESS_EXPIRED: "Sesión expirada.",
      PASSWORD_EXPIRED: "Contraseña expirada.",
      NEED_CHANGE_PASSWORD: "Se requiere cambiar la contraseña",
      ENTITY_NOT_FOUND: "No se encontró el usuario",
    },
    info: {
      NEED_CHANGE_PASSWORD:
        "Es tu primer acceso, es necesario cambiar la contraseña",
    },
    success: {
      validation: "Validación exitosa",
      changePassword: "Se cambió la contraseña",
      resendCode: "Enviamos un codigo de confirmación a tu correo electronico!",
    },
  },
  accounts: {
    errors: {
      gettingAccount:
        "Ha ocurrido un error obteniendo la información de la cuenta, por favor, contacta a soporte.",
    },
  },
  importAndExport: {
    downloadTemplate: "Descargar plantilla excel",
    success: {
      imported: "Importación en curso",
      exported: "Exportación en curso",
    },
  },
  users: {
    title: "Usuarios",
    entity: {
      id: "id",
      name: "Nombre",
      email: "Correo electrónico",
      password: "Contraseña",
      profile: "Perfil",
      createdAt: "Fecha Creación",
      updatedAt: "Fecha de Actualización",
      status: "Estado",
      mainPosition: "Posición principal",
      positions: "Posiciones secundarias",
    },
    settings: {
      customFields: "CAMPOS PERSONALIZADOS",
      import: "IMPORTAR",
      export: "EXPORTAR",
    },
    modals: {
      importModal: "IMPORTAR USUARIOS",
      exportTitle: "EXPORTAR DE USUARIOS",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      UNKNOWN_ERROR:
        "Ha ocurrido un error inesperado al obtener el usuario, contacta a soporte",
      ENTITY_ALREADY_EXIST: "El usuario ya existe",
    },
    success: {
      userCreated: "Usuario creado",
      userUpdated: "Usuario actualizado",
      userDeleted: "Usuario borrado",
      statusUpdated: "Estado del usuario actualizado",
    },
    warnings: {
      status: "Atención de cambio de estado",
    },
    form: {
      createTitle: "Crear usuario",
      editTitle: "Editar usuario",
      viewTitle: "Visualizar usuario",
      add: "Agregar usuario",
      update: "Actualizar usuario",
    },
    table: {
      label: "Tabla de Usuarios",
      actions: "Acciones",
      actionList: {
        enable: "Activar",
        disable: "Desactivar",
        edit: "Editar",
        delete: "Eliminar",
        view: "Ver",
      },
    },
    questionDelete:
      "¿Estás seguro de eliminar el usuario <strong>{name}</strong>?",
    questionEnable:
      "¿Estás seguro de activar al usuario <strong>{name}</strong>?",
    questionDisable:
      "¿Estás seguro de desactivar al usuario <strong>{name}</strong>?",
  },
  header: {
    navbar: {
      elements: {
        home: "INICIO",
        usersManagment: {
          name: "GESTIÓN DE USUARIOS",
          dropdowns: {
            users: "USUARIOS",
            profiles: "PERFILES",
            positions: "POSICIONES",
          },
        },
        crm: {
          name: "CRM",
          dropdowns: {
            customers: "CLIENTES",
            suppliers: "PROVEEDORES",
          },
        },
        productsManagment: {
          name: "GESTIÓN DE PRODUCTOS",
          dropdowns: {
            products: "PRODUCTOS",
            rawMaterials: "MATERIAS PRIMAS",
            productFamily: "FAMILIAS DE PROD.",
            measures: "MEDIDAS",
          },
        },
        operations: {
          name: "OPERACIONES",
          dropdowns: {
            orders: "PEDIDOS",
            shipping: "ENVÍOS",
            inventories: {
              name: "INVENTARIOS",
              dropdowns: {
                productInventory: "INVENTARIO DE PRODUCTO",
                rawMaterialsInventory: "INVENTARIO DE MATERIA PRIMA",
              },
            },
          },
        },
        divisions: "DIVISIONES",
        stores: "ALMACENES",
        workplace: "CENTRO DE TRABAJO",
        reports: "REPORTES",
        settings: "CONFIGURACIÓN",
      },
    },
  },
  catalogs: {
    USERS_STATUS_CLASS: "Estado de los usuarios",
    EMPLOYEES_STATUS_CLASS: "Estado de los empleados",
  },
  customFields: {
    title: "Campos personalizados",
    singularTitle: "Campo Personalizado",
    value: "Valor",
    create: "Crear campo personalizado",
    name: "Nombre del campo",
    required: "Requerido",
    type: "Tipo de campo",
    types: {
      text: "Texto",
      number: "Número",
      select: "Selección única",
      multipleSelect: "Selección múltiple",
      date: "Fecha",
    },
    option: "Ingrese opción",
    default: "Valor por defecto",
    regularExpression: "Expresión Regular",
    unitOfMeasurement: "Unidad de Medida",
    min: "Valor mínimo",
    max: "Valor máximo",
    negativeInfinity: "-Infinito",
    positiveInfinity: "+Infinito",
    selectionLimit: "Cantidad de selecciones simultáneas",
    values: "Ingrese valores",
    addField: "Agregar Campo",
    save: "Guardar",
    translates: "Traducciones del valor",
    settings: "Configuraciones",
    optionsValues: "Valores de opción",
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Campo personalizado ya exitente.",
    },
    success: {
      customFieldCreated: "Campo personalizado creado",
      customFieldUpdated: "Campo personalizado actualizado",
      customFieldDeleted: "Campo personalizado borrado",
    },
    yupRules: {
      isEmailYup: "email",
      minCharsYup: "carácteres mínimos",
      minSpecialCharsYup: "carácteres especiales mínimos",
      minNumbersYup: "números mínimos",
      minUpperCaseYup: "mayúsculas mínimas",
      minLowerCaseYup: "minúsculas mínimas",
      positiveYup: "positivo",
      integerYup: "entero",
      isGreaterYup: "mayor o igual que",
      isLessYup: "menor o igual que",
      isPositiveNumberYup: "positivo",
    },
    quantity: `Cantidad de {name}`,
    addOption: "Ingrese opción {optionIndex}",
    updateField: "Actualizar campo",
    questionDelete:
      "¿Estás seguro de eliminar el campo personalizado llamado <strong>{name}</strong>?",
    isCurrency: "Es una divisa",
    validations: "Validaciones",
  },
  permissions: {},
  profiles: {
    title: "Perfiles",
    entity: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Edición",
      permissions: "Permisos",
    },
    table: {
      actions: "Acciones",
      actionList: {
        enable: "Activar",
        disable: "Desactivar",
        edit: "Editar",
        delete: "Eliminar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear Perfil",
      editTitle: "Editar Perfil",
      viewTitle: "Visualizar Perfil",
      add: "Agregar Perfil",
      update: "Actualizar Perfil",
      selectNewProfile: "Seleccione un nuevo perfil",
      deleteAndReplace: "Reemplazar y eliminar perfil",
    },
    success: {
      created: "Perfil creado",
      updated: "Perfil actualizado",
      deleted: "Perfil borrado",
      deletedAndReplaced: "Perfil borrado y reemplazado",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Perfil ya exitente.",
    },
    warnings: {
      deleteAndReplace:
        "Los <b>usuarios</b> que posean el perfil <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
  },
  measures: {
    title: "Medidas",
    entity: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
    },
    modals: {
      importModal: "IMPORTAR MEDIDAS",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Las medida ya existe",
    },
    success: {
      created: "Medida creada",
      updated: "Medida actualizada",
      deleted: "Medida borrada",
    },
    warnings: {
      status: "Atención de cambio de medidas",
      deleteAndReplace:
        "Los <b>productos</b> que tengan la medida <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
    form: {
      createTitle: "Crear Medida",
      editTitle: "Editar Medida",
      viewTitle: "Visualizar Medida",
      add: "Agregar medida",
      update: "Actualizar medida",
      deleteAndReplace: "Reemplazar y borrar medida",
      selectNewMeasure: "Seleccione una nueva medida",
    },
    tables: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    questionDelete:
      "¿Estás seguro de eliminar las medidas <strong>{name}</strong>?",
  },
  rawMaterials: {
    title: "Materias Primas",
    entity: {
      id: "Id",
      code: "Código",
      description: "Descripción",
      materialType: "Tipo de Material",
      unitCost: "Costo Unitario",
      thickness: "Espesor",
      width: "Ancho",
      length: "Profundidad",
      volume: "Volumen",
      warehouseLocation: "Ubicación en Almacén",
      supplier: "Proveedor",
      measure: "Medida",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
      status: "Estado",
      stock: "Existencias",
    },
    modals: {
      importModal: "IMPORTAR MATERIAS PRIMAS",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "La materia prima ya existe",
    },
    success: {
      created: "Materia prima creada",
      updated: "Materia prima actualizada",
      deleted: "Materia prima borrada",
    },
    warnings: {
      status: "Atención de cambio de materia prima",
    },
    form: {
      createTitle: "Crear Materia Prima",
      editTitle: "Editar Materia Prima",
      viewTitle: "Visualizar Materia Prima",
      add: "Agregar materia prima",
      update: "Actualizar materia prima",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    questionDelete:
      "¿Estás seguro de eliminar la materia prima <strong>{name}</strong>?",
  },
  productFamilies: {
    title: "Familia de productos",
    entity: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      permissions: "Permisos",
      createdAt: "Fecha de Creación",
    },
    modals: { importModal: "IMPORTAR FAMILIA DE PRODUCTOS" },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear Familia de Producto",
      editTitle: "Editar Familia de Producto",
      viewTitle: "Visualizar Familia de Producto",
      add: "Agregar familia de producto",
      update: "Actualizar familia de producto",
      deleteAndReplace: "Reemplazar y eliminar",
      selectNewProductFamily: "Seleccione una nueva familia de producto",
    },
    warnings: {
      deleteAndReplace:
        "Los <b>productos</b> que tengan la familia de producto <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
    success: {
      updated: "Familia de producto actualizada",
      created: "Familia de producto creada",
      deleted: "Familia de producto eliminada",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Familia de producto ya exitente.",
    },
  },
  products: {
    title: "Productos",
    technicalSheetsTitle: "Fichas Tecnicas",
    workplacesFlowsTitle: "Flujos de centros de trabajo",
    entity: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      price: "Precio",
      createdAt: "Fecha de Creación",
      measure: "Medida",
      productFamily: "Familia de producto",
      permissions: "Permisos",
      technicalSheet: "Ficha técnica",
      stock: "Existencias",
    },
    settings: {
      import: "IMPORTAR",
      export: "EXPORTAR",
      customFields: "CAMPOS PERSONALIZADOS",
      workplacesFlowsCustomFields: "C.P. DE FLUJOS DE CENTRO DE TRABAJO",
      technicalSheetsCustomFields: "C.P. DE FICHAS TÉCNICAS",
    },
    modals: {
      importModal: "IMPORTAR PRODUCTOS",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
      filters: {
        technicalSheet: {
          exists: "Existe",
          notExists: "No existe",
        },
      },
    },
    form: {
      createTitle: "Crear Producto",
      editTitle: "Editar Producto",
      viewTitle: "Visualizar Producto",
      add: "Agregar Producto",
      update: "Actualizar Producto",
      technicalSheet: "¿Desea crear/modificar ficha técnica?",
      workplaceFlow: "¿Desea crear/modificar el flujo de centro de trabajo?",
      technicalSheetTitle: "Ficha Tecnica",
      workplacesFlowTitle: "Flujo de centros de trabajo",
    },
    success: {
      created: "Producto creado",
      updated: "Producto actualizado",
      deleted: "Producto eliminado",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Producto ya exitente.",
    },
    questionDelete:
      "¿Estás seguro de eliminar el producto <strong>{name}</strong>?",
  },
  customers: {
    title: "Clientes",
    entity: {
      id: "Id",
      name: "Nombre",
      customerType: "Tipo de Cliente",
      businessType: "Tipo de Negocio",
      state: "Estado",
      city: "Ciudad",
      email: "Correo",
      status: "Estatus",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
      division: "División",
    },
    settings: {
      customFields: "CAMPOS PERSONALIZADOS",
      import: "IMPORTAR",
      export: "EXPORTAR",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear Cliente",
      editTitle: "Editar Cliente",
      viewTitle: "Visualizar Cliente",
      add: "Agregar Cliente",
      update: "Actualizar Cliente",
    },
    success: {
      created: "Cliente creado",
      updated: "Cliente actualizado",
      deleted: "Cliente eliminado",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Cliente ya existe",
    },
    questionDelete:
      "¿Estás seguro de eliminar al cliente <strong>{name}</strong>?",
  },
  suppliers: {
    title: "Proveedores",
    entity: {
      id: "Id",
      code: "Código",
      name: "Nombre",
      email: "Correo Electrónico",
      phone: "Número de teléfono",
      supplierType: "Tipo de proveedor",
      businessType: "Tipo de negocio",
      supplierState: "Estado",
      city: "Ciudad",
      status: "Estatus",
      createdAt: "Fecha de creación",
      updatedAt: "Fecha de actualización",
      division: "División",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear Proveedor",
      editTitle: "Editar Proveedor",
      viewTitle: "Visualizar Proveedor",
      add: "Agregar Proveedor",
      update: "Actualizar Proveedor",
      deleteAndReplace: "Reemplazar y eliminar",
      selectNewSupplier: "Seleccione un nuevo proveedor",
    },
    success: {
      created: "Proveedor creado",
      updated: "Proveedor actualizado",
      deleted: "Proveedor eliminado",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Proveedor ya exitente.",
    },
    warnings: {
      deleteAndReplace:
        "Las <b>materias primas</b> que posean el proveedor <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
  },
  positions: {
    title: "Posiciones",
    entity: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      baseSalary: "Salario Base",
      createdAt: "Fecha de creación",
      updatedAt: "Fecha de actualización",
      division: "División",
    },
    modals: {
      importModal: "IMPORTAR POSICIONES",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear Posición",
      editTitle: "Editar Posición",
      viewTitle: "Visualizar Posición",
      add: "Agregar Posición",
      update: "Actualizar Posición",
    },
    success: {
      created: "Posición creada",
      updated: "Posición actualizada",
      deleted: "Posición eliminada",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "La posición ya existe",
    },
    questionDelete:
      "¿Estás seguro de eliminar la posición <strong>{name}</strong>?",
  },
  orders: {
    title: "Órdenes",
    entity: {
      id: "Id",
      orderDate: "Fecha de la Orden",
      customer: "Cliente",
      customerType: "Tipo de Cliente",
      total: "Total",
      status: "Estatus",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "La orden ya existe",
      DETAILS_EMPTY: "Se requiere al menos un detalle",
    },
    success: {
      created: "Orden creada",
      updated: "Orden actualizada",
      deleted: "Orden borrada",
    },
    warnings: {
      status: "Atención con el estado de la orden",
    },
    form: {
      createTitle: "Crear Orden",
      editTitle: "Editar Orden",
      viewTitle: "Visualizar Orden",
      add: "Agregar orden",
      update: "Actualizar orden",
    },
    tables: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    questionDelete:
      "¿Estás seguro de eliminar la orden <strong>{name}</strong>?",
  },
  orderDetail: {
    title: "Detalle",
    entity: {
      product: "Producto",
      quantity: "Cantidad",
      subtotal: "Subtotal",
      discount: "Descuento",
      discountType: {
        title: "Tipo de descuento",
        options: {
          0: "Monto",
          1: "Porcentaje",
        },
      },
    },
    form: {
      createTitle: "Crear detalle de orden",
      editTitle: "Actualizar detalle de orden",
      add: "Agregar detalle de orden",
      update: "Actualizar detalle de orden",
    },
  },
  divisions: {
    title: "Divisiones",
    entity: {
      id: "Id",
      name: "Nombre",
      location: "Localización",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
    },
    settings: {
      import: "IMPORTAR",
      export: "EXPORTAR",
      customFields: "CAMPOS PERSONALIZADOS",
    },
    modals: {
      importModal: "IMPORTAR DIVISIONES",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear División",
      editTitle: "Editar División",
      viewTitle: "Visualizar División",
      add: "Agregar División",
      update: "Actualizar División",
      selectNewDivision: "Seleccione una nueva división",
      deleteAndReplace: "Seleccionar y reemplazar",
    },
    success: {
      created: "División creada",
      updated: "División actualizada",
      deleted: "División eliminada",
    },
    warnings: {
      deleteAndReplace:
        "Los <b>centros de trabajo</b> e <b>inventarios</b> que tengan la división <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      SAME_ENTITY: "División ya existente.",
    },
    questionDelete:
      "¿Estás seguro de eliminar la división <strong>{name}</strong>?",
  },
  workplaces: {
    title: "Centros de trabajos",
    entity: {
      id: "Id",
      name: "Nombre",
      description: "Descripción",
      status: "Estatus",
      division: "División",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
    },
    settings: {
      customFields: "CAMPOS PERSONALIZADOS",
      import: "IMPORTAR",
      export: "EXPORTAR",
    },
    modals: {
      importModal: "IMPORTAR CENTRO DE TRABAJO",
    },
    table: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    form: {
      createTitle: "Crear Centro de Trabajo",
      editTitle: "Editar Centro de Trabajo",
      viewTitle: "Visualizar Centro de Trabajo",
      add: "Agregar Centro de Trabajo",
      update: "Actualizar Centro de Trabajo",
    },
    success: {
      created: "Centro de Trabajo creado",
      updated: "Centro de Trabajo actualizado",
      deleted: "Centro de Trabajo eliminado",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Centro de Trabajo ya exitente.",
    },
    questionDelete:
      "¿Estás seguro de eliminar el centro de trabajo <strong>{name}</strong>?",
  },
  technicalSheets: {
    title: "Ficha Técnica : {name} - {measure}",
    entity: {
      name: "Nombre del producto: ",
      description: "Descripción",
      status: "Estatus",
      division: "División",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
      rawMaterial: "Materias Primas",
      preManufacturedProduct: "Producto Semi-elaborado",
      materialType: "Tipo de Material",
      quantity: "Cantidad",
      thickness: "Espesor",
      width: "Ancho",
      length: "Largo",
      unitVolume: "Volumen Unitario",
      totalVolume: "Volumen Total",
      images: "Imágenes",
      manufactureSpecification: {
        title: "Especificaciones de fabricación",
        subtitle: "Especificaciones y observaciones",
        images: "Imagenes",
        details: "Detalle {index}",
      },
      instructions: {
        title: "Instrucción de colocación y ubicación de sellos",
        images: "Imágenes",
        description: "Descripción",
      },
      qualityCriteria: {
        title: "Listado de verificación de criterios de calidad",
        order: "Orden {index}",
        criteriaOrder: "Órden",
        description: "Descripción {index}",
        isValid: "¿Se cumple?",
        validation: "Validez {index}",
        observations: "Observaciones",
      },
      customfields: "Campos Personalizados de la ficha técnica",
    },
    view: {
      title: "FICHA TÉCNICA DEL PRODUCTO",
    },
    type: {
      new: "Nuevo",
      recycled: "Reciclado",
      mixed: "Mixto",
    },
    form: {
      createTitle: "Crear Ficha Técnica",
      editTitle: "Editar Ficha Técnica",
      add: "Agregar Ficha Técnica",
      update: "Actualizar Ficha Técnica",
      rawMaterial: {
        add: "Agregar Materia Prima",
        update: "Actualizar Materia Prima",
      },
      preManufacturedProduct: {
        add: "Agregar Producto Semielaborado",
        update: "Actualizar Producto Semielaborado",
      },
    },
    tables: {
      rawMaterials: {
        actionList: {
          edit: "Editar",
          delete: "Eliminar",
        },
        isEmpty: "No hay materias primas para mostrar",
      },
    },
    success: {
      created: "Ficha Técnica creada",
      updated: "Ficha Técnica actualizada",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Ficha Técnica ya exitente.",
    },
  },
  workplacesFlows: {
    title: "Flujo de Centros de trabajos",
    entity: {
      workplace: "Centro de trabajo",
      description: "Descripción",
      workTime: "Duración",
      step: "Número de paso",
      customfields: "Campos Personalizados de la secuencia operativa",
    },
    form: {
      title: "Lista de Pasos",
      operativeSequency: "Secuencia operativa",
      createTitle: "Editar Flujo de Centros de Trabajo",
      update: "Actualizar Flujo de Centros de Trabajo",
      updateStep: "Actualizar Paso",
      addStep: "Agregar Paso",
    },
    success: {
      created: "Flujo de Centros de Trabajo creado",
      updated: "Flujo de Centros de Trabajo actualizado",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "Flujo de Centros de Trabajo ya exitente.",
    },
    questionDelete:
      "¿Estás seguro de eliminar el flujo de centros de trabajo <strong>{name}</strong>?",
  },
  stores: {
    title: "Almacenes",
    entity: {
      id: "Id",
      name: "Nombre",
      division: "División",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
    },
    settings: {
      customFields: "CAMPOS PERSONALIZADOS",
      import: "IMPORTAR",
      export: "EXPORTAR",
    },
    modals: {
      importModal: "IMPORTAR ALMACENES",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "El almacen ya existe",
    },
    success: {
      created: "Almacén creado",
      updated: "Almacén actualizado",
      deleted: "Almacén borrado",
    },
    warnings: {
      status: "Atención de cambio de almacén",
      deleteAndReplace:
        "Los <b>inventarios</b> que tengan el almacén <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
    form: {
      createTitle: "Crear Almacén",
      editTitle: "Editar Almacén",
      viewTitle: "Visualizar Almacén",
      add: "Agregar almacén",
      update: "Actualizar almacén",
      deleteAndReplace: "Reemplazar y borrar almacén",
      selectNewStore: "Seleccione un nuevo almacén",
    },
    tables: {
      actions: "Acciones",
      actionList: {
        edit: "Editar",
        delete: "Borrar",
        view: "Ver",
      },
    },
    questionDelete:
      "¿Estás seguro de eliminar el almacén <strong>{name}</strong>?",
  },
  inventories: {
    rawMaterialsTitle: "Inventario de materias primas",
    productsTitle: "Inventario de productos",
    entity: {
      id: "Id",
      product: "Producto",
      rawMaterial: "Materia Prima",
      store: "Almacén",
      quantity: "Cantidad",
      lotCode: "Código de lote",
      expirationDate: "Fecha de expiración",
      createdAt: "Fecha de Creación",
      updatedAt: "Fecha de Actualización",
    },
    type: {
      rawMaterials: "materias primas",
      products: "productos",
    },
    errors: {
      ACCESS_EXPIRED: "Tu sesión ha expirado, vuelve a iniciar sesión.",
      ENTITY_ALREADY_EXIST: "El inventario ya existe",
    },
    success: {
      inserted: "Inventario insertado",
      dispatched: "Inventario despachado",
      updated: "Inventario actualizado",
    },
    warnings: {
      status: "Atención de cambio de transacción",
      deleteAndReplace:
        "Las <b>transacciones</b> que tengan el product/materia prima <b>{ name }</b> (id <b>{ id }</b>) serán reemplazados por el nuevo que seleccione.",
    },
    form: {
      insertProductTitle: "Insertar producto",
      insertRawMaterialTitle: "Insertar materia prima",
      dispatchProductTitle: "Despachar producto",
      dispatchRawMaterialTitle: "Despachar materia prima",
      modifyProductTitle: "Modificar inventario de producto",
      modifyRawMaterialTitle: "Modificar inventario de materia prima",
      viewProductTitle: "Visualizar inventario de producto",
      viewRawMaterialTitle: "Visualizar inventario de materia prima",
      insert: "Insertar transacción",
      dispatch: "Despachar transacción",
      modify: "Modificar transacción",
    },
    tables: {
      actions: "Acciones",
      actionList: {
        modify: "Modificar",
        dispatch: "Despachar",
        view: "Ver",
      },
    },
    questionDelete:
      "¿Estás seguro de eliminar la transacción <strong>{name}</strong>?",
  },
};
